import { IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IAccount } from "@gtmhub/core";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { ISubscriptionConverted } from "@gtmhub/login/models";
import { IPlan, PricingEditionService } from "@gtmhub/edition-plan-change";

enum UpgradeButtonState {
  STATIC = "static",
  TRIAL = "trial",
}

const gtmhubScaleV2 = "gtmhub-scale-v2";

export class TrialInfoCtrl {
  secondsLeft: number;
  percentageTimeLeft: number;
  timeLeft: string;
  account: IAccount;
  isAccountTrial: boolean;
  isDemoAccount: boolean;
  isInternalAccount: boolean;
  availableUpgradePlans: IPlan[];
  accountTypes: {
    trial: number;
    client: number;
    internal: number;
    demo: number;
  };
  upgradeButtonState: UpgradeButtonState;

  private isAccountConverted: boolean;

  public static $inject = ["$scope", "AccountResolverService", "$state", "PricingEditionService"];

  constructor(
    private $scope: IScope,
    private accountResolverService: AccountResolverService,
    private $state: StateService,
    private priceEditionService: PricingEditionService
  ) {
    this.accountTypes = {
      trial: 0,
      client: 1,
      internal: 2,
      demo: 3,
    };

    this.account = this.accountResolverService.getAccountData();

    if (this.account.subscriptions.length) {
      this.isAccountConverted = this.account.subscriptions.find((license) => license.type === "regular").isConverted;
    }

    this.isAccountTrial = this.account.type === this.accountTypes.trial && !this.isAccountConverted;
    this.isDemoAccount = this.account.type === this.accountTypes.demo;
    this.isInternalAccount = this.account.type === this.accountTypes.internal;

    this.checkExpiration();
    this.upgradeButtonState = this.setUpgradeButtonState();

    this.$scope.$on("subscriptionConverted", (evt, subscriptionConverted: ISubscriptionConverted) => this.subscriptionConverted(subscriptionConverted));

    this.priceEditionService.getAllowedTransitions(this.account.type).then((plans) => {
      this.availableUpgradePlans = plans;
    });
  }

  goToBilling(): void {
    this.$state.go("gtmhub.editionPlanChange");
  }

  showUpgradePlanButton(): boolean {
    if (!this.availableUpgradePlans?.length) {
      return false;
    }

    return !this.isDemoAccount && !this.isInternalAccount && (this.account.edition.name !== gtmhubScaleV2 || this.isAccountTrial);
  }

  private setUpgradeButtonState(): UpgradeButtonState {
    if (this.account.edition.name === "gtmhub-essential") {
      return UpgradeButtonState.STATIC;
    }

    return this.secondsLeft > 0 ? UpgradeButtonState.TRIAL : UpgradeButtonState.STATIC;
  }

  private checkExpiration(): void {
    const trialExpiration = this.accountResolverService.checkExpirationOfTrialAccount();
    this.secondsLeft = trialExpiration.secondsLeft;
    this.timeLeft = trialExpiration.timeLeft;
    this.percentageTimeLeft = trialExpiration.percentageTimeLeft;
  }

  private subscriptionConverted(subscriptionConverted: ISubscriptionConverted) {
    if (this.account.id === subscriptionConverted.accountId) {
      const subscriptionTypeRegular = subscriptionConverted.subscriptions.find((license) => license.type === "regular");
      this.isAccountTrial = !subscriptionTypeRegular.isConverted;
      this.$scope.$apply();
    }
  }
}
